import './_footer.scss'

const Footer = () => {
    return (
        <p className="footer">Created by <a href="https://github.com/camain-elie" target="_blank" rel="noreferrer" className="footer__link">Elie C.</a> - devChallenge.io</p>
    )
}

export default Footer